function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

/* eslint-disable shopify/prefer-early-return */
import React, { useCallback, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { pushCustomEvent } from '../../trackers/utils';
import Modal from '../../common/components/modal';
import CustomerSupportMenu from '../components/customerSupportMenu';
export default function CustomerSupportMenuContainer(_ref) {
  var triggerElem = _ref.triggerElem,
      mobileTriggerElem = _ref.mobileTriggerElem,
      nextFocusElem = _ref.nextFocusElem;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      triggerHovered = _useState2[0],
      setTriggerHovered = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      menuHovered = _useState4[0],
      setMenuHovered = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      menuOpenByKeyboard = _useState6[0],
      setMenuOpenByKeyboard = _useState6[1];

  var _useState7 = useState(false),
      _useState8 = _slicedToArray(_useState7, 2),
      modalOpen = _useState8[0],
      setModalOpen = _useState8[1];

  var _useState9 = useState(),
      _useState10 = _slicedToArray(_useState9, 2),
      locationStyle = _useState10[0],
      setLocationStyle = _useState10[1];

  var _useState11 = useState(),
      _useState12 = _slicedToArray(_useState11, 2),
      lastKeyDown = _useState12[0],
      setLastKeyDown = _useState12[1];

  var handleKeyDown = useCallback(function (_ref2) {
    var key = _ref2.key,
        shiftKey = _ref2.shiftKey;

    if (key === 'Escape') {
      setTriggerHovered(false);
      setMenuOpenByKeyboard(false);
    }

    setLastKeyDown({
      key: key,
      shiftKey: shiftKey
    });
  }, []);
  useEffect(function () {
    function handleTriggerEnter() {
      setTriggerHovered(true);
      setMenuOpenByKeyboard(false);
    }

    function handleTriggerLeave() {
      setTriggerHovered(false);
    }

    $(triggerElem).on('keydown', function (evt) {
      if (evt.key === 'Enter') {
        setMenuOpenByKeyboard(true);
      }
    });
    triggerElem.addEventListener('mouseenter', handleTriggerEnter);
    triggerElem.addEventListener('mouseleave', handleTriggerLeave);

    function handleMobileTriggerClick() {
      setModalOpen(true);
    }

    mobileTriggerElem.addEventListener('click', handleMobileTriggerClick);
    $(mobileTriggerElem).on('keydown', function (evt) {
      if (evt.key === 'Enter') {
        setModalOpen(true);
        setMenuOpenByKeyboard(true);
      }
    });
    document.addEventListener('keydown', handleKeyDown, false);
    return function () {
      triggerElem.removeEventListener('mouseenter', handleTriggerEnter);
      triggerElem.removeEventListener('mouseleave', handleTriggerLeave);
      $(triggerElem).off('keydown');
      mobileTriggerElem.removeEventListener('click', handleMobileTriggerClick);
      $(mobileTriggerElem).off('keydown');
      document.removeEventListener('keydown', handleKeyDown, false);
    };
  }, []);
  useEffect(function () {
    if (triggerHovered || menuOpenByKeyboard) {
      var _triggerElem$getBound = triggerElem.getBoundingClientRect(),
          top = _triggerElem$getBound.bottom,
          left = _triggerElem$getBound.left;

      setLocationStyle({
        top: top,
        left: left,
        position: 'absolute',
        width: 400
      });
    }
  }, [triggerHovered, menuOpenByKeyboard]);
  useEffect(function () {
    if (modalOpen) {
      setLocationStyle({});
    }
  }, [modalOpen]);

  function handleChatNowClick() {
    setTriggerHovered(false);
    setMenuHovered(false);
    setModalOpen(false);
  }

  function handleModalCloseClick() {
    pushCustomEvent('modal_exit_click', 'custom_engage', 'customer_support');
    setModalOpen(false);
  }

  function handleMenuBlur() {
    if (menuOpenByKeyboard) {
      var elemToFocus = triggerElem;

      if (lastKeyDown && lastKeyDown.key === 'Tab' && !lastKeyDown.shiftKey) {
        elemToFocus = nextFocusElem;
      }

      setTimeout(function () {
        return elemToFocus.focus();
      }, 10);
    }

    setTriggerHovered(false);
    setMenuOpenByKeyboard(false);
  }

  var csMenu = /*#__PURE__*/React.createElement(CustomerSupportMenu, {
    isOpen: triggerHovered || menuHovered || menuOpenByKeyboard || modalOpen,
    isOpenByKeyboard: menuOpenByKeyboard,
    locationStyle: locationStyle,
    onBlur: handleMenuBlur,
    onMouseEnter: function onMouseEnter() {
      return setMenuHovered(true);
    },
    onMouseLeave: function onMouseLeave() {
      return setMenuHovered(false);
    },
    onChatNowClick: handleChatNowClick
  });
  /* eslint-disable quotes */

  var modalMenu = /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Modal, {
    isOpen: modalOpen,
    onRequestClose: function onRequestClose() {
      return setModalOpen(false);
    },
    onCloseClick: handleModalCloseClick,
    contentLabel: "Customer Support - How Can We Help You?"
  }, csMenu));
  return modalOpen ? modalMenu : csMenu;
}
CustomerSupportMenuContainer.propTypes = {
  triggerElem: PropTypes.object,
  mobileTriggerElem: PropTypes.object,
  nextFocusElem: PropTypes.object
};